import { render, staticRenderFns } from "./PerOrder.vue?vue&type=template&id=7fa02a13&scoped=true&"
import script from "./PerOrder.vue?vue&type=script&lang=ts&"
export * from "./PerOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PerOrder.vue?vue&type=style&index=0&id=7fa02a13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa02a13",
  null
  
)

export default component.exports